import React from "react";

type HeaderVoucherProps = {
    t: (key: string) => string;
    voucherCode: string;
    discount: string;
}

const HeaderVoucher = ({ t, voucherCode, discount }: HeaderVoucherProps) => {
    return (
      <div className="d-none d-lg-flex ms-2 flex-column">
        <div className="d-flex mt-3">
          <div className="me-4">
            <h6 className="text-muted mb-0">{t("Voucher Code")}</h6>
            <h6 className="mb-0 fw-bold letter-spacing-1">{voucherCode.toUpperCase()}</h6>
          </div>
          <div>
            <h6 className="text-muted mb-0">{t("Commission")}</h6>
            <h6 className="mb-0 text-success">{discount}%</h6>
          </div>
        </div>
      </div>
    );
};

export default HeaderVoucher;